import {
    Alert,
    Button,
    Col,
    Divider,
    Form,
    Input,
    Modal,
    Row,
    Spin,
    Table,
    Tag,
    Typography,

} from 'antd';
import locale from 'antd/es/locale/pt_BR';
import React from 'react';

import DateFnsUtils from '@date-io/date-fns';
import ptLocale from "date-fns/locale/pt-BR";


import { DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { useSolicitacoesDeUpgrade } from './useSolicitacoesDeUpgrade';
import Icon from '@ant-design/icons';
import { IconComponentProps } from '@ant-design/icons/lib/components/Icon';
import { ReactComponent as LogoSVG } from './../../../../assets/svgs/solicitacao_upgrade.svg';
import LogoPNG from './../../../../assets/pngs/solicitacao_upgrade.png';

const { Text } = Typography;

const LogoCustomizadaIcon: React.FC<any> = (props) => (
    <Icon component={LogoSVG} {...props} />
);

const SolicitacoesDeUpgrade: React.FC = () => {

    const {
        navigateAddUser,
        clickBotaoEditarUsuario,
        hasSelectedEdit,
        onChangeSelectFiltroBuscaTabela,
        selectedRowKeys,
        ativarOuInativarModulo,
        onClickInativarUser,
        onClickAtivarUser,
        clickBotaoDeletarDados,
        visibleAlertDeAtencaoCache,
        spinAlertDeAtencaoCache,
        setVisibleAlertDeAtencaoCache,
        setSpinAlertDeAtencaoCache,
        valorSelecione,
        buscaDadosUsuariosAtivosAndSetTable,
        buscaDadosVendedoresAndSetTable,
        buscaDadosUsuariosInativosAndSetTable,
        buscaDadosTodosusuariosAndSetTable,
        loadingTable,
        onclickTable,
        rowSelection,
        dadosTabelaState,
        columns,
        refContagemDoFiltro,
        propsState,
        navigateGerenciar,
        visibleModal,
        setVisibleModal,
        handleAtender,
        solicitacaoUpSelected,
        returnCorTag,
        refFormModal,
        selectedDateVincularUserRapido,
        setSelectedDateVincularUserRapido,
        clickSubmitModalSolicitacaoUpgrade,
        clickCloseModalSolicitacaoUpgrade,
    } = useSolicitacoesDeUpgrade();

    return (
        <>
            <Row
            // style={{ marginBottom: 16 }}
            >
                <Col span={24}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center'
                    }}>
                        <img
                            src={LogoPNG}
                            alt={'Solicitação de upgrade'}
                            style={{
                                width: '50px',
                                height: '50px',
                                filter: propsState.theme === 'light' ?
                                    'brightness(0) saturate(100%) invert(9%) sepia(0%) saturate(0%) hue-rotate(192deg) brightness(99%) contrast(86%)'
                                    :
                                    'brightness(0) saturate(100%) invert(100%) sepia(89%) saturate(32%) hue-rotate(352deg) brightness(93%) contrast(85%)'
                                ,
                            }}
                        // className={className}
                        />
                        <Typography.Title level={3} style={{marginBottom: 0}}>
                            {/* <IconCogs style={{ fontSize: 35 }} /> */}
                            {/* <LogoCustomizadaIcon style={{ fontSize: 100, color: 'red' }} /> */}
                            {'Listagem de Solicitações de Upgrade'}
                        </Typography.Title>
                    </div>
                    {/* <Breadcrumb>
                        <Breadcrumb.Item>
                            <a
                            // onClick={onClickVoltarConfigOfSystem}
                            >
                                {'Solicitações de Upgrade'}
                            </a>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>{'Editar Solicitação de Ativação'}</Breadcrumb.Item>
                    </Breadcrumb> */}
                    <Divider />
                </Col>
            </Row>
            <div
                style={{
                    position: 'fixed',
                    zIndex: 2,
                    paddingTop: 24,
                    paddingBottom: 10,
                    paddingLeft: 24,
                    paddingRight: 10,
                    margin: -24
                }}
            >
                <Row
                // style={{ marginBottom: 16 }}
                >
                    <Col>
                        {/* <Button type="primary"
                            style={{ marginRight: 5, marginBottom: 5 }} className="btn_success_vlhbegoawrgbvr" disabled={!hasSelectedAdd}
                            onClick={navigateAddUser}
                        >
                            Adicionar
                        </Button> */}
                        <Button
                            type="primary"
                            style={{ marginRight: 5, marginBottom: 5 }}
                            onClick={handleAtender}
                            disabled={!hasSelectedEdit}
                        >
                            Atender
                        </Button>
                    </Col>
                    {/* <Col>
                        <Button type="primary"
                            style={{ marginRight: 5, marginBottom: 5 }}
                            className="btn_warning_cewuyfgfvewofc" onClick={clickBotaoEditarUsuario} disabled={!hasSelectedEdit}
                        >
                            Editar
                        </Button>
                    </Col>

                    <Col>
                        <Select
                            showSearch
                            placeholder="Selecione..."
                            optionFilterProp="children"
                            style={{ marginRight: 5, marginBottom: 5 }}
                            onChange={onChangeSelectFiltroBuscaTabela}
                            disabled={!hasSelectedAdd}
                            defaultValue='Usuários'
                            filterOption={(input: any, option: any) => {
                                let textDigit = removeAcento(input)
                                let listCidade = removeAcento(option?.children);
                                return listCidade.indexOf(textDigit) >= 0
                            }}
                        >
                            <Select.Option value="Usuários">Ativos</Select.Option>
                            <Select.Option value="Vendedores">Vendedores</Select.Option>
                            <Select.Option value="Inativos">Inativos</Select.Option>
                            <Select.Option value="Todos">Todos</Select.Option>
                        </Select>
                    </Col>
                    <Col>
                        {selectedRowKeys.length === 1 ?
                            ativarOuInativarModulo ?
                                <Button type="primary"
                                    style={{ marginRight: 5, marginBottom: 5 }}
                                    danger onClick={onClickInativarUser}
                                    // disabled={!hasSelectedDel}
                                    disabled={!hasSelectedEdit}
                                >
                                    Inativar
                                </Button>
                                :
                                <Button className="btn_success_vlhbegoawrgbvr"
                                    style={{ marginRight: 5, marginBottom: 5 }}
                                    type="primary" onClick={onClickAtivarUser}
                                    // disabled={!hasSelectedDel}
                                    disabled={!hasSelectedEdit}
                                >
                                    Ativar
                                </Button>

                            : <Button type="primary"
                                style={{ marginRight: 5, marginBottom: 5 }}
                                danger onClick={onClickInativarUser}
                                // disabled={!hasSelectedDel}
                                disabled
                            >
                                Inativar
                            </Button>}
                    </Col>
                    <Col>

                        <Popconfirm
                            title="Deseja excluir?"
                            onConfirm={clickBotaoDeletarDados}
                            onCancel={() => { }}
                            okText="Sim"
                            cancelText="Não"
                        >
                            <Button
                                // className="botaoDeleteAssociacao"
                                type="primary"
                                danger
                                disabled={!hasSelectedEdit}
                                style={{ marginRight: 5, marginBottom: 5 }}
                            >
                                <DeleteOutlined />
                            </Button>
                        </Popconfirm>
                    </Col> */}
                </Row>

            </div>
            {
                visibleAlertDeAtencaoCache &&
                <Alert
                    message="Atenção"
                    description="Atualizando cache de usuários."
                    type="info"
                    className='marginTopAlertEnsimaTable'
                    style={{
                        marginTop: 50,
                        marginBottom: -40
                    }}
                    showIcon
                    action={
                        <>
                            {
                                spinAlertDeAtencaoCache ?

                                    <Spin spinning={true} />
                                    :
                                    <Button size="small" onClick={() => {

                                        setVisibleAlertDeAtencaoCache(false);
                                        setSpinAlertDeAtencaoCache(true);

                                        if (valorSelecione === 'Usuários') {

                                            buscaDadosUsuariosAtivosAndSetTable();

                                        } else if (valorSelecione === 'Vendedores') {

                                            buscaDadosVendedoresAndSetTable();
                                        } else if (valorSelecione === 'Inativos') {

                                            buscaDadosUsuariosInativosAndSetTable();
                                        } else if (valorSelecione === 'Todos') {

                                            buscaDadosTodosusuariosAndSetTable();
                                        }
                                    }
                                    } type="primary">
                                        Atualizar
                                    </Button>
                            }
                        </>
                    }
                />
            }
            <Table
                style={{
                    marginTop: 50
                }}
                className='marginTopTables'
                // rowClassName={(record, index) => (record.ativo ? "ativoList" : "inativoList")}
                rowKey={(record) => record.uuid}
                loading={loadingTable}
                onRow={(record, rowIndex) => {
                    return {
                        onClick: event => { onclickTable(record, rowIndex) },
                    };
                }}
                rowSelection={rowSelection}
                columns={columns} dataSource={dadosTabelaState?.solicitacoes || []}
                scroll={{ x: 1000 }}
                onChange={
                    (pagination, filters, sorter, extra) => {
                        refContagemDoFiltro.current = extra.currentDataSource
                    }
                }
                title={(registros) => {

                    return (
                        <div
                            style={{
                                backgroundColor: propsState.theme === 'light' ? '#FAFAFA' : '#1D1D1D',
                                padding: 10,
                                margin: -8,
                                marginBottom: 0.5
                            }}
                        >
                            <Text>
                                {/* {`Total: ${dadosTabelaState.length} registros.`} */}
                                {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                                    dadosTabelaState?.solicitacoes.length :
                                    refContagemDoFiltro.current.length} num total de ${dadosTabelaState?.solicitacoes.length} `}
                            </Text>
                        </div>
                    )
                }}
                footer={(registros) => {
                    return (
                        <div
                            style={{
                                textAlign: 'end'
                            }}
                        >
                            <Text>
                                {/* {`Total: ${dadosTabelaState.length} registros.`} */}
                                {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                                    dadosTabelaState?.solicitacoes.length :
                                    refContagemDoFiltro.current.length} num total de ${dadosTabelaState?.solicitacoes.length} `}
                            </Text>
                        </div>
                    )
                }}
                size="small"
                pagination={{
                    locale: { items_per_page: '' },
                    showSizeChanger: true,
                    defaultPageSize: 100,
                    // showTotal: (total, range) => {
                    //     return (`Mostrando: ${range[0]} ao ${range[1]} num total de ${total} itens`)
                    // },
                    position: ['topRight', 'bottomRight'],
                    pageSizeOptions: ['10', '20', '50', '100']
                }}
                locale={locale.Table}
            />
            <Modal
                title="Solicitação de Upgrade"
                open={visibleModal}
                destroyOnClose
                onOk={clickCloseModalSolicitacaoUpgrade}
                onCancel={clickCloseModalSolicitacaoUpgrade}
                style={{
                    top: 20
                }}
                width={650}
                className="modalInfoCardCalculo1234etc_ckwghcvewoFDSBVA"
                footer={[
                    <Button
                        type="default"
                        onClick={clickCloseModalSolicitacaoUpgrade}
                        key={'btnCancelarSolicitacaoUpgrade'}
                    >
                        Fechar
                    </Button>,
                ]}
                key="modalSolicitacaoUpgrade"
            >
                <Spin spinning={loadingTable}>
                    <div>
                        <Row style={{ justifyContent: 'space-between' }}>

                            <Col
                                style={{
                                    marginBottom: 10
                                }}
                                xs={24} sm={12} lg={8}
                            >
                                <Text
                                    style={{
                                        marginRight: 5
                                    }}
                                >
                                    {"Módulo: "}
                                </Text>
                                {
                                    solicitacaoUpSelected?.modulo && solicitacaoUpSelected?.modulo?.nome ?
                                        <Text
                                            style={{
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            {solicitacaoUpSelected?.modulo.nome}
                                        </Text>
                                        :
                                        '--'
                                }
                            </Col>
                            <Col
                                style={{
                                    marginBottom: 10
                                }}
                                xs={24} sm={12} lg={8}
                            >
                                <Text
                                    style={{
                                        marginRight: 5
                                    }}
                                >
                                    {"Contrato: "}
                                </Text>
                                {
                                    solicitacaoUpSelected?.contrato && solicitacaoUpSelected?.contrato?.nome ?
                                        <Text
                                            style={{
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            {solicitacaoUpSelected?.contrato.nome}
                                        </Text>
                                        :
                                        '--'
                                }
                            </Col>
                            <Col
                                style={{
                                    marginBottom: 10
                                }}
                                xs={24} sm={12} lg={8}
                            >
                                <Text
                                    style={{
                                        marginRight: 5
                                    }}
                                >
                                    {"Plano: "}
                                </Text>
                                {
                                    solicitacaoUpSelected?.contrato && solicitacaoUpSelected?.contrato?.plano &&
                                        solicitacaoUpSelected?.contrato?.plano?.nome ?
                                        <Text
                                            style={{
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            {solicitacaoUpSelected?.contrato.plano.nome}
                                        </Text>
                                        :
                                        '--'
                                }
                            </Col>
                            <Col
                                style={{
                                    marginBottom: 10
                                }}
                                xs={24} sm={12} lg={8}
                            >
                                <Text
                                    style={{
                                        marginRight: 5
                                    }}
                                >
                                    {"Atendida: "}
                                </Text>
                                {
                                    typeof solicitacaoUpSelected?.atendida === 'boolean' ?
                                        <Tag {...returnCorTag(solicitacaoUpSelected?.atendida)} />
                                        :
                                        '--'
                                }
                            </Col>
                            <Col
                                style={{
                                    marginBottom: 10
                                }}
                                xs={24} sm={12} lg={8}
                            >
                                <Text
                                    style={{
                                        marginRight: 5
                                    }}
                                >
                                    {"Usuário: "}
                                </Text>
                                {
                                    solicitacaoUpSelected?.usuario && solicitacaoUpSelected?.usuario?.nome ?
                                        <Text
                                            style={{
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            {solicitacaoUpSelected?.usuario?.nome}
                                        </Text>
                                        :
                                        '--'
                                }
                            </Col>
                            <Col
                                style={{
                                    marginBottom: 10
                                }}
                                xs={24} sm={12} lg={8}
                            >
                                <Text
                                    style={{
                                        marginRight: 5
                                    }}
                                >
                                    {"Observação: "}
                                </Text>
                                {
                                    typeof solicitacaoUpSelected?.observacao === 'string' ?
                                        <Text
                                            style={{
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            {solicitacaoUpSelected?.observacao}
                                        </Text>
                                        :
                                        '--'
                                }
                            </Col>
                        </Row>
                        {

                            (typeof solicitacaoUpSelected?.atendida === 'boolean' && !solicitacaoUpSelected?.atendida) ?
                                <>

                                    <Divider />

                                    <Typography.Title level={5}>
                                        {'Atender Solicitação'}
                                    </Typography.Title>
                                    <Form
                                        ref={refFormModal}
                                        name="formModalSolicitacaoUpgrade"
                                        layout="vertical"
                                        initialValues={{
                                            remember: true,
                                        }}
                                    >
                                        <Row>
                                            <Col span={24}>
                                                <Form.Item
                                                    rules={[
                                                        {
                                                            required: false,
                                                            message: "Preencha o data!",
                                                        },
                                                    ]}
                                                    name="dataProximoContato"
                                                    label="Próx. Contato"
                                                // style={{ margin: 5 }}
                                                >
                                                    <MuiPickersUtilsProvider locale={ptLocale} utils={DateFnsUtils} >
                                                        <DateTimePicker
                                                            value={selectedDateVincularUserRapido}
                                                            onChange={setSelectedDateVincularUserRapido}
                                                            required={false}
                                                            style={{
                                                                width: '100%'
                                                            }}
                                                            okLabel="Ok"
                                                            clearLabel="Limpar"
                                                            cancelLabel="Cancelar"
                                                            clearable
                                                            format="dd/MM/yyyy HH:mm"
                                                            className="datePickerCOlors"
                                                        />
                                                    </MuiPickersUtilsProvider>
                                                </Form.Item>
                                            </Col>
                                            <Col span={24}>
                                                <Form.Item
                                                    rules={[
                                                        {
                                                            required: false,
                                                            message: "Por favor comente!",
                                                        }
                                                    ]}
                                                    name="observacao"
                                                    label="Observação"
                                                >
                                                    <Input.TextArea style={{ maxHeight: 200, height: 100 }} />
                                                </Form.Item>
                                            </Col>
                                            <Col span={24}>
                                                <Button
                                                    // key="submit"
                                                    type="primary"
                                                    onClick={clickSubmitModalSolicitacaoUpgrade}
                                                >
                                                    Salvar
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Form>
                                </>
                                :
                                null
                        }
                    </div>
                </Spin>
            </Modal>
        </>
    );
}

export default SolicitacoesDeUpgrade;
